import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgLeft = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M16.882 2.415a1.333 1.333 0 01-.048 1.885L8.624 12l8.21 7.7a1.333 1.333 0 11-1.837 1.933L4.751 12l10.246-9.633a1.333 1.333 0 011.885.048z", clipRule: "evenodd" })));
};
export default SvgLeft;
//# sourceMappingURL=Left.js.map